import SvgIcon from "@client/components/reusable/SvgIcons";
import { ReactComponent as CheckboxEmptyWhite } from "@client/components/reusable/SvgIcons/library/checkbox_empty_white.svg";
import { ReactComponent as CheckboxEmpty } from "@client/components/reusable/SvgIcons/library/checkbox_empty.svg";
import { ReactComponent as CheckBoxFull } from "@client/components/reusable/SvgIcons/library/checkbox_full.svg";

interface CheckboxIconProps {
	checked: boolean;
	emptyVariant?: "gray" | "white";
	wrapperClassName?: string;
	width?: string;
	height?: string;
}

export default function CheckboxIcon({
	checked,
	emptyVariant = "gray",
	wrapperClassName,
	width = "16",
	height = "16",
}: CheckboxIconProps) {
	const emptyIcon =
		emptyVariant === "white" ? CheckboxEmptyWhite : CheckboxEmpty;

	return (
		<div className={wrapperClassName}>
			<SvgIcon
				component={checked ? CheckBoxFull : emptyIcon}
				width={width}
				height={height}
			/>
		</div>
	);
}
